import { Component, inject, Input, OnInit, ViewChild } from '@angular/core';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { MaintenancePlanEnums } from 'src/app/enum/maintenance-routine-enums';
import { ElementModel } from 'src/app/models/maintenance/element.model';
import { MaintenanceRoutineDetailTableModel } from 'src/app/models/tables/maintenance/maintenance-routine-detail-table.model';
import { MaintenanceRoutineDetailService } from 'src/app/services/maintenance/maintenance-routine-detail.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { RegisterMaintenanceRoutineDetailComponent } from '../register-maintenance-routine-detail/register-maintenance-routine-detail.component';
import { ConfirmDialogService } from './../../../../services/confirm-dialog/confirm-dialog.service';

@Component({
  selector: 'app-maintenance-routine-detail',
  templateUrl: './maintenance-routine-detail.component.html',
  styleUrls: ['./maintenance-routine-detail.component.scss'],
  standalone: false
})
export class MaintenanceRoutineDetailComponent implements OnInit {
  private readonly maintenanceRoutineDetailService = inject(MaintenanceRoutineDetailService);
  private readonly confirmDialogService = inject(ConfirmDialogService);
  private readonly toastHandlerService = inject(ToastHandlerService);

  @ViewChild('activitiesModal') activitiesModalComponent?: CustomModalComponent | null = null;

  @Input('elementModel') set changeDate(change: ElementModel) {
    this.changeElement(change);
  }
  @Input() permissionUpdatable: boolean = false;
  @Input() active: boolean = false;
  @Input() disabledForm: boolean = false;

  maintenanceRoutineDetails: MaintenanceRoutineDetailTableModel[] = [];
  elementModel: ElementModel = new ElementModel();
  registerDetailModal = RegisterMaintenanceRoutineDetailComponent;
  inputsForRegister$ = new BehaviorSubject<any>({
    elementModel: new ElementModel()
  });
  swEachUse: number = MaintenancePlanEnums.swEachUse;
  swMaintenancePlan1: number = MaintenancePlanEnums.swMaintenancePlan1;
  swMaintenancePlan2: number = MaintenancePlanEnums.swMaintenancePlan2;
  swMaintenancePlan3: number = MaintenancePlanEnums.swMaintenancePlan3;
  swMaintenancePlan4: number = MaintenancePlanEnums.swMaintenancePlan4;
  swMaintenancePlan5: number = MaintenancePlanEnums.swMaintenancePlan5;
  swMaintenancePlan6: number = MaintenancePlanEnums.swMaintenancePlan6;
  swMaintenancePlan7: number = MaintenancePlanEnums.swMaintenancePlan7;
  output$ = new Subject<any>();
  subscription: Subscription;


  ngOnInit() {
    this.subscription = this.output$.subscribe(({ type }) => {
      switch (type) {
        case 'updateList':
          this.getMaintenanceRoutineDetailsByElementId();
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  addActivities() {
    if (this.elementModel.elementId == 0) {
      this.toastHandlerService.showToast('warning', `Debe seleccionar el elemento.`, 'Atención.');
      return;
    } else if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('error', `El usuario no tiene permisos para agregar actividades.
          Comuníquese con el administrador del sistema.`);
      return;
    }

    this.inputsForRegister$.next({
      elementModel: this.elementModel
    });
    this.activitiesModalComponent?.show();
  }

  async changeCheckBox(activity: MaintenanceRoutineDetailTableModel, maintenancePlan: number) {
    try {
      await firstValueFrom(this.maintenanceRoutineDetailService.updateAsync(activity.maintenanceRoutineDetailId, maintenancePlan));
    } catch (error) {
      console.error('Error al actualizar la actividad.', error);
    }
  }


  changeElement(change: ElementModel) {
    this.elementModel = change;
    if (this.elementModel.elementId != 0) {
      this.getMaintenanceRoutineDetailsByElementId();
    } else {
      this.maintenanceRoutineDetails = [];
    }
  }

  async getMaintenanceRoutineDetailsByElementId() {
    try {
      const response = await firstValueFrom(this.maintenanceRoutineDetailService.getMaintenanceRoutineDetailsByElementIdAsync(this.elementModel.maintenanceRoutineId, this.elementModel.elementId));
      this.maintenanceRoutineDetails = response;
    } catch (error) {
      console.error('Error al obtener lo elementos por id.', error);
    }
  }

  async delete(activity: MaintenanceRoutineDetailTableModel) {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('error', `El usuario no tiene permisos para eliminar actividades.
            Comuníquese con el administrador del sistema.`);
      return;
    }

    const accepted = await this.confirmDialogService.confirm('¿Realmente desea eliminar la actividad?');
    if (accepted) {
      try {
        await firstValueFrom(this.maintenanceRoutineDetailService.deleteDetail(activity.maintenanceRoutineDetailId));
        await this.getMaintenanceRoutineDetailsByElementId();
        this.toastHandlerService.showToast('success', 'La actividad fue eliminada exitosamente.');
      } catch (error) {
        console.error('Error al eliminar la actividad.', error);
      }
    }
  }
}
